import React, { useState, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Button, Row, Col, Container, Collapse } from 'reactstrap'
import { I18n } from 'react-redux-i18n'

import { conversationPassengersAct } from 'redux_new/actions'
import { composerAct } from 'redux/actions'
import { apiUsers } from 'api'
import { PassengerCard } from 'components/Cards'
import allowedDomains from 'constants/allowed-domains'
import ModalPassenger from './ModalPassenger'

import './styles.scss'
import Nixi1Spinner from 'components/Nixi1Spinner'

const ConversationPassengers = ({ userId }) => {
  const conversationPassengers = useSelector((store) => store.conversationPassengers[userId] || store.conversationPassengers.initial)
  const dispatch = useDispatch()

  const { passengers, isOpen, isLoading } = conversationPassengers
  const passengersSize = passengers.length

  const [showModal, setShowModal] = useState(false)
  const [passengerId, setPassengerId] = useState(null)

  // Collapse dropdown
  const onClickCollapse = useCallback(
    () => dispatch(isOpen ? conversationPassengersAct.close() : conversationPassengersAct.get()),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isOpen]
  )

  // Show modal and edit address
  const onEdit = useCallback(
    (passengerId) => {
      setPassengerId(typeof passengerId === 'number' ? passengerId : null)
      setShowModal(!showModal)
    },
    [showModal]
  )

  const onCreateLink = async () => {
    try {
      const { data: { result } } = await apiUsers.passengers.getWebviewLink(userId)
      await dispatch(composerAct.addExternalText(`${I18n.t('messages_webviewLink')}▶️ ${result} ◀️`))

    } catch (error) {
      console.error(error)
    }
  }

  return (
    <div className='plugin-address-card'>
      <div className='title-container'>
        <div className='title'>
          <i className={'fa fa-ticket nav-icon-resources'} />
          {I18n.t('dashboard_passengers')}
        </div>
        <div className='action-buttons-container'>
          <i className={`fa fa-chevron-${isOpen ? 'up' : 'down'}`} onClick={onClickCollapse} />
        </div>
      </div>
      <Collapse isOpen={isOpen}>
        <div className='separator' />
        <Container className='plugin-passengers mt-3'>
          {isLoading ? (
            <Nixi1Spinner height='23px' width='23px'/>
          ) : passengersSize === 0 ? (
            <div>{I18n.t('dashboard_user-not-entered-passengers-system')}</div>
          ) : (
            passengers.map((passenger, idx) => <PassengerCard key={passenger.passport} passenger={passenger} handleClick={() => onEdit(idx)} />)
          )}
          {
            <Row className='mt-3'>
              <Col className='text-right'>
                <Button color='primary' onClick={onEdit}>
                  {I18n.t('dashboard_add-passenger')}
                </Button>
              </Col>
              {
                allowedDomains.type !== 'OP' && (
                  <Col className='text-left'>
                    <Button color='primary' onClick={onCreateLink}>
                      {I18n.t('dashboard_create-link')}
                    </Button>
                  </Col>
                )
              }
            </Row>
          }
          {isOpen && !isLoading ? (
            <ModalPassenger showModal={showModal} currentPassenger={passengers[passengerId] || null} onCloseModal={onEdit} />
          ) : null}
        </Container>
      </Collapse>
    </div>
  )
}

export default React.memo(ConversationPassengers)
